// extracted by mini-css-extract-plugin
export var connectionButton = "_bq-1";
export var rightPanel = "_bq-3";
export var stepDescription = "_bq-2";
export var stepIcon = "_bq-0";